import './personalportfoliotext.css'

export default function PersonalPortfolioText() {

    return (
        <div>
            <p className = "headerTag">Personal Portfolio 2022</p>
        </div>
    )
}
